import { render } from "./AiAndMemory.vue?vue&type=template&id=2d3293bb&scoped=true"
import script from "./AiAndMemory.vue?vue&type=script&lang=js"
export * from "./AiAndMemory.vue?vue&type=script&lang=js"

import "./AiAndMemory.vue?vue&type=style&index=0&id=2d3293bb&scoped=true&lang=css"

import exportComponent from "/home/runner/work/mehimself.github.io/mehimself.github.io/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d3293bb"]])

export default __exports__